import React, { useState } from 'react';
import './Login.css';
import apiService from './api';

function Login({ onLogin }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLogging, setIsLogging] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLogging(true);
    setError('');
    
    try {
      const response = await apiService.login(username, password);
      
      if (response.success) {
        onLogin(response.username);
      } else {
        setError(response.message || 'Login failed');
      }
    } catch (error) {
      setError('Connection error: ' + error.message);
    } finally {
      setIsLogging(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <h1>Indibids Admin Login</h1>
        <form onSubmit={handleSubmit} className="login-form">
          <div className="form-group">
            <label>Username:</label>
            <input
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="Enter username"
              required
              disabled={isLogging}
            />
          </div>
          
          <div className="form-group">
            <label>Password:</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter password"
              required
              disabled={isLogging}
            />
          </div>
          
          {error && <div className="error-message">{error}</div>}
          
          <button type="submit" className="login-button" disabled={isLogging}>
            {isLogging ? 'Logging in...' : 'Login'}
          </button>
        </form>
        
        <div className="login-help">
          <p><strong>Backend Status:</strong></p>
          <p>✅ React Frontend: Running</p>
          <p>🔄 Connecting to Python Backend...</p>
        </div>
      </div>
    </div>
  );
}

export default Login;
